/* tslint:disable */

/**
 */
export class UpdateShiftForm {
    shift_id?: number;
    user_id?: number;
    subdriver_id?: number;
}
